import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF7F2] px-4">
      <div className="w-full max-w-md text-center bg-white rounded-2xl border border-stone-200 p-10">
        <XCircle className="mx-auto text-stone-400" size={48}/>
        <div className="font-serif-display text-2xl font-bold mt-4">Checkout cancelled</div>
        <p className="text-stone-600 mt-2">No worries — you weren't charged. You can upgrade anytime.</p>
        <div className="flex gap-3 justify-center mt-6">
          <Button asChild variant="outline"><Link to="/dashboard">Dashboard</Link></Button>
          <Button asChild className="bg-[#C85A32] hover:bg-[#B04B26]"><Link to="/upgrade">Try again</Link></Button>
        </div>
      </div>
    </div>
  );
}
